<template>
<div>
  
  <el-dialog
    title="日程管理"
    :visible.sync="dialogVisible"
    width="60%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <!-- 搜索区 -->
    <DirectRecordSearch
      :searchOptions="searchOptions"
      :searchData="searchParams"
      @onSearch="getList"
      @clearAll="onSearch"
    />
    <el-button class="mb20" @click="edit" type="primary" >新建</el-button>
    <c-table
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :tabIndexPageReset="true"
        :pager="true"
        :query="searchParams"
        :api="getClassScheduleList"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        @handleClick="handleClick"
        @handleEvent="handleEvent"
      >
        <!-- 自定义列表内容 -->
        <template v-slot:col-arrange="scope">
          <p>{{ getType(scope.row.scheduleType) }}</p>
          <p>{{ scope.row.title }}</p>
          <p>{{ scope.row.speaker }}</p>
        </template>
        <!-- 自定义列表内容 -->
        <template v-slot:col-date="scope">
          {{ scope.row.date}}
        </template>
        <!-- 自定义列表内容 -->
        <template v-slot:col-startTime="scope">
          {{ scope.row.startTime }} - {{ scope.row.endTime }}
        </template>
        <!-- 自定义列表内容 -->
        <!-- <template v-slot:col-state="scope">
          <p>{{ scope.row.status === 1 ? '已停用' : '已启用' }}</p>
        </template> -->
        <!-- 自定义插槽状态按钮 -->
        <!-- <template v-slot:bt-state="scope">
          <el-button
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.row.status === 2 ? '停用' : '启用' }}
          </el-button>
        </template> -->
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-delete="scope">
          <el-button
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
    </c-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>

  <HandleDateManage ref='dialogDateManage' :editParams='editChildParams' @success='getList'></HandleDateManage>
</div>
</template>

<script>
import CTable from '@/components/PublicTableCopy';
import DirectRecordSearch from "@/components/Search/index";
import HandleDateManage from "./handle-date-manage";
import { getClassScheduleList,updateFaceClassStatus,delClassSchedule } from '@/api/api'
export default {
  components: {
    CTable,
    DirectRecordSearch,
    HandleDateManage
  },
  props: {
    editParams: {
      type: Object,
      default: function(){
        return {}
      }
    }
  },
  data() {
    return {
      getClassScheduleList,
      dialogVisible: false,
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        fieldList: [
          // { label: '排序号', value: 'id' },
          { label: '日期', value: 'date',  type: 'slot'},
          { label: '时间', value: 'startTime', type: 'slot' },
          { label: '日程安排', value: 'arrange', type: 'slot'},
        ],
        handle: {
          label: '操作',
          btList: [
            { label: '启用', type: 'text', event: 'state', show: true, slot: true },
            { label: '删除', type: 'text', event: 'delete', show: true, slot: true },
            { label: '编辑', type: 'text', event: 'edit', show: true },
          ]
        }
      },
      editChildParams:{},
      // 搜索表单配置项
      searchOptions: [
        {
          type: "input",
          label: "日程安排关键词",
          prop: "keyWord",
          width: "230px",
          placeholder: "请输入班级名称",
          // querySearchAsync: querySearchAsync,
        },
      ],
      searchParams: {
      },
    };
  },
  mounted(){
    this.getList();
  },
  methods: {
    getType(num){
      if( num == 1 ){
        return '课程'
      }else if( num == 2 ){
        return '实训';
      }else if( num == 3 ){
        return '考察'
      }else if( num == 4 ){
        return '开班典礼'
      }else if( num == 5 ){
        return '结业典礼'
      }else if( num == 1 ){
        return '用餐'
      }
    },
    // 通过随机数请求列表
    getList() {
      this.tableInfo.refresh = Math.random();
    },
    // table数据
    handleEvent(data) {
      this.tableInfo.data = data.records;
    },
    showDialog(componentName){
      this.$refs[componentName].setOpacity(true)
    },
    setOpacity(flg) {
      console.log('显示')
      this.dialogVisible = flg;
      this.$nextTick(()=>{
        this.getList();
      })
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 查询
    onSearch(data) {
        console.log(data)
    },
    edit(){
      this.editChildParams = {
        classId:this.editParams.id,
        name:this.editParams.name
      }
      this.showDialog('dialogDateManage');
    },
    handleClick(event,row){
      console.log(row)
      if (event === 'edit') {
        this.edit();
        this.editChildParams = row;
      } else if (event === 'state') {
        updateFaceClassStatus({
          id: row.id,
          status:row.status === 1 ? 2 : 1
        }).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success(row.state === 1 ? '启用成功' : '停用成功');
            this.getList();
          } else {
            this.$message.error(message);
          }
        })
      } else {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delClassSchedule({
            id: row.id
          }).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('删除成功');
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        });
      }
    },
    // 切换选择
    changeTableSelection(val) {
      console.log(val);
    },
  },
   watch: {
    editParams: {
      immediate: true,
      handler(newValue, oldValue) {
        this.searchParams.classId = newValue.id
      },
    },
  },
};
</script>

<style lang="scss">
.w50{
  width: 50%;
  display: inline-block;
}
.el-dialog__body{
  // max-height: 50vh;
  overflow-y: auto;
}
</style>
<style lang='scss' scoped>
.mb20{
  margin-bottom: 20px;
}
</style>
